<template>
  <div>
    <el-dialog
      class="modal"
      title="合法帳號"
      :visible.sync="legalAccountDialog"
      width="375px"
    >
      <el-table
        stripe
        :data="currentData.legal_account"
        border
        style="width: 100%;margin-top:18px"
      >
        <el-table-column type="index" width="50" align="center" label="序" />
        <el-table-column header-align="center" align="center" label="帳號">
          <template slot-scope="scope">
            <el-tooltip
              style="cursor:pointer"
              v-clipboard:copy="scope.row"
              v-clipboard:success="$onCopy"
              class="item copyHover"
              effect="dark"
              content="點擊複製"
              placement="top"
            >
              <p>
                {{ scope.row }}
              </p>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="legalAccountDialog = false" class="oBtn">關閉</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      title="導出數據"
      :visible.sync="exportModal"
      width="375px"
    >
      <p class="text-danger" style="text-align:center">
        <span
          v-if="
            $store.state.userStatus != 'customer' &&
              $store.state.userStatus != 'customerSub'
          "
        >
          用戶未填為不指定,
        </span>
        日期預設為當日
      </p>
      <div class="radioForm" style="margin:10px 0">
        <div class="radioWrap">
          <el-radio v-model="exportRadio" label="created_at">創建時間</el-radio>
          <el-radio v-model="exportRadio" label="completed_at"
            >完成時間</el-radio
          >
        </div>
        <el-date-picker
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="exportDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="開始日期"
          end-placeholder="結束日期"
          :default-time="['00:00:00', '23:59:59']"
          :picker-options="{ disabledDate: $store.state.disabledDate }"
        >
        </el-date-picker>
      </div>
      <el-input
        v-if="
          $store.state.userStatus != 'customer' &&
            $store.state.userStatus != 'customerSub'
        "
        placeholder="用戶號"
        v-model="exportId"
        autocomplete="off"
      ></el-input>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="exportModal = false" class="btn">關閉</div>
        <div @click="confirmExport" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      width="375px"
      :visible.sync="legalAccountModal"
      title="確認支付方式"
    >
      <el-dialog
        width="375px"
        title="再次確認"
        :visible.sync="legalAccountInner"
        append-to-body
      >
        <p class="text-danger">
          注意!此操作不可逆請謹慎操作
        </p>
        <p>商戶{{ currentData.customer_id }}</p>
        <p>確認支付方式?</p>
        <div slot="footer" class="dialog-footer btnGroup">
          <div @click="legalAccountInner = false" class="btn">關閉</div>
          <div @click="confirmLegalAccount" class="btn">確認</div>
        </div>
      </el-dialog>
      <div class="modalBody">
        <p class="text-danger">
          注意!此操作不可逆請謹慎操作
        </p>
        <p>商戶{{ currentData.customer_id }}</p>
        <p>確認支付方式?</p>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="legalAccountModal = false" class="btn">關閉</div>
        <div @click="legalAccountInner = true" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      width="375px"
      :visible.sync="checkAmountModal"
      title="確認真實金額"
    >
      <el-dialog
        width="375px"
        title="再次確認"
        :visible.sync="checkAmountInner"
        append-to-body
      >
        <p class="text-danger">
          注意!此操作不可逆請謹慎操作
        </p>
        <p>商戶{{ currentData.customer_id }}</p>
        <p>確認訂單回調實際金額?</p>
        <div slot="footer" class="dialog-footer btnGroup">
          <div @click="checkAmountInner = false" class="btn">關閉</div>
          <div @click="confirmCheckAmount" class="btn">確認</div>
        </div>
      </el-dialog>
      <div class="modalBody">
        <p class="text-danger">
          注意!此操作不可逆請謹慎操作
        </p>
        <p>商戶{{ currentData.customer_id }}</p>
        <p>確認訂單回調實際金額?</p>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="checkAmountModal = false" class="btn">關閉</div>
        <div @click="checkAmountInner = true" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      width="475px"
      :visible.sync="queryOrderModal"
      title="三方查單"
    >
      <el-dialog
        width="375px"
        title="三方查單"
        :visible.sync="queryOrderInner"
        append-to-body
      >
        <p>訂單號{{ currentData.transaction_id }}</p>
        <el-descriptions
          border
          :column="1"
          v-if="typeof queryOrderData == 'object'"
        >
          <el-descriptions-item
            v-for="(query, key) in queryOrderData"
            :key="key"
            labelStyle="white-space:nowrap"
            :label="key"
          >
            <pre style="word-break: break-all;">
              {{ query }}
            </pre>
          </el-descriptions-item>
        </el-descriptions>
        <pre style="word-break: break-all;" v-else>{{
          queryOrderData.message || queryOrderData
        }}</pre>
        <div slot="footer" class="dialog-footer btnGroup">
          <div @click="queryOrderInner = false" class="oBtn">關閉</div>
        </div>
      </el-dialog>
      <div class="modalBody">
        <p>
          是否三方查單
        </p>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="queryOrderModal = false" class="btn">關閉</div>
        <div @click="confirmQueryOrder" class="btn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      width="375px"
      :visible.sync="errorModal"
      title="三方回應"
    >
      <div class="modalBody">
        <p class="text-danger" v-if="errorViewContent == 'null'">
          請檢查三方域名是否正確或是否需要添加白名單
        </p>
        <p class="text-danger">
          {{
            errorViewContent == "null"
              ? "逾時沒有回應"
              : "請將下列信息反饋至三方詢問"
          }}
        </p>
        <div class="content d-flex justify-content-center w-100">
          <div class="text-white contentWrap text-center">
            <p style="word-break: break-all;">{{ errorViewContent }}</p>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="errorModal = false" class="oBtn">關閉</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      width="375px"
      :visible.sync="rateTableModal"
      title="匯率"
    >
      <div class="modalBody" v-if="rateTableModal">
        <el-descriptions border :column="1" v-if="rateTable.nTable">
          <el-descriptions-item label="匯率">{{
            rateTable.rate
          }}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions border :column="1" v-else>
          <el-descriptions-item label="匯率">{{
            rateTable.trans[Object.keys(rateTable.trans)[0]].rate
          }}</el-descriptions-item>
          <el-descriptions-item label="幣別">{{
            Object.keys(rateTable.trans)[0]
          }}</el-descriptions-item>
          <el-descriptions-item label="原始金額">{{
            rateTable.trans[Object.keys(rateTable.trans)[0]].original_amount
          }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="rateTableModal = false" class="oBtn">關閉</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      width="80%"
      :visible.sync="orderInfoModal"
      title="訂單詳情"
    >
      <div class="modalBody" v-if="orderInfoModal">
        <el-descriptions border :column="3">
          <el-descriptions-item label="渠道名稱" :span="3">{{
            currentData.channel_alias
          }}</el-descriptions-item>
          <el-descriptions-item label="請求IP" :span="3">{{
            currentData.c_detail
              ? JSON.parse(currentData.c_detail).client_ip
              : ""
          }}</el-descriptions-item>
          <el-descriptions-item label="產品名稱">
            {{
              currentData.c_detail
                ? JSON.parse(currentData.c_detail).pay_product_name
                : ""
            }}
          </el-descriptions-item>
          <el-descriptions-item label="收銀臺創建">
            {{ currentData.counter ? "√" : "×" }}
          </el-descriptions-item>
          <el-descriptions-item label="真實姓名">
            {{
              currentData.c_detail
                ? JSON.parse(currentData.c_detail).user_name
                : ""
            }}
          </el-descriptions-item>
          <el-descriptions-item label="強制補單">
            {{ currentData.force_order ? "√" : "×" }}
          </el-descriptions-item>
          <el-descriptions-item label="過期時間">
            {{ currentData.expired_at }}
          </el-descriptions-item>
          <el-descriptions-item label="商戶回調">
            {{ currentData.manual_callback ? "√" : "×" }}
          </el-descriptions-item>
          <el-descriptions-item label="開單地區" :span="3">
            {{ JSON.parse(currentData.c_detail).billing_area }}
          </el-descriptions-item>
          <el-descriptions-item label="結帳地區" :span="3">
            {{ JSON.parse(currentData.c_detail).checkout_area }}
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          v-if="reqLogData"
          border
          :column="6"
          title="請求三方"
          style="margin-top:15px"
        >
          <el-descriptions-item label="地址" :span="6" labelClassName="nowrap">
            <p v-if="reqLogData" style="white-space:pre-wrap">
              {{ reqLogData["請求網址"] }}
              <span v-if="reqLogData && reqLogData['請求耗時']">
                | 請求耗時:</span
              >
              {{ reqLogData["請求耗時"] }}
            </p>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          v-if="reqLogData"
          border
          :column="6"
          direction="vertical"
        >
          <el-descriptions-item
            label="內容"
            labelClassName="nowrap"
            contentClassName="w-50"
          >
            <pre style="white-space:pre-wrap"
              >{{ reqLogData["請求內容"] }}
            </pre>
          </el-descriptions-item>
          <el-descriptions-item
            label="響應"
            labelClassName="nowrap"
            contentClassName="w-50"
          >
            <pre style="white-space:pre-wrap"
              >{{ reqLogData["三方響應"] }}
            </pre>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          border
          :column="5"
          title="回調商戶"
          style="margin-top:15px"
          v-if="reqNotifyData"
        >
          <el-descriptions-item label="地址" :span="6" labelClassName="nowrap">
            <p v-if="reqNotifyData" style="white-space:pre-wrap">
              {{ reqNotifyData["回調地址"] }}
              <span v-if="reqNotifyData && reqNotifyData['請求耗時']">
                | 請求耗時:</span
              >
              {{ reqNotifyData["請求耗時"] }}
            </p>
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          border
          :column="5"
          v-if="reqNotifyData"
          direction="vertical"
        >
          <el-descriptions-item
            label="內容"
            labelClassName="nowrap"
            contentClassName="w-50"
          >
            <pre style="white-space:pre-wrap"
              >{{ reqNotifyData["回調內容"] }}
            </pre>
          </el-descriptions-item>
          <el-descriptions-item
            label="響應"
            labelClassName="nowrap"
            contentClassName="w-50"
          >
            <pre style="white-space:pre-wrap"
              >{{ reqNotifyData["商戶響應"] }}
            </pre>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="orderInfoModal = false" class="oBtn">關閉</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      width="375px"
      :visible.sync="editPayModal"
      title="設置訂單為已支付"
    >
      <div class="modalBody">
        <p class="text-danger">注意!此操作不可逆請謹慎操作</p>
        <p>{{ currentData.transaction_id }}</p>

        <el-form
          label-position="top"
          :model="currentData"
          class="demo-form-inline"
        >
          <el-form-item label="補單金額">
            <el-input
              v-model="currentData.amount"
              placeholder="補單金額"
            ></el-input>
          </el-form-item>
          <el-form-item label="付款人帳號/店號 (payer_info)">
            <el-input
              v-model="currentData.payer_info"
              placeholder="付款人帳號/店號"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="editPayModal = false" class="oBtn">關閉</div>
        <div @click="editPayModalInner = true" class="oBtn">確定</div>
      </div>
      <el-dialog
        width="375px"
        title="設置訂單為已支付"
        :visible.sync="editPayModalInner"
        append-to-body
      >
        <p>訂單號:{{ currentData.transaction_id }}</p>
        <p>補單金額:{{ currentData.amount }}</p>
        <p v-if="currentData.payer_info">
          付款人帳號/店號:{{ currentData.payer_info }}
        </p>
        <div slot="footer" class="dialog-footer btnGroup">
          <div @click="editPayModalInner = false" class="oBtn">關閉</div>
          <div @click="confirmEditPay" class="oBtn">確定</div>
        </div>
      </el-dialog>
    </el-dialog>
    <el-dialog
      class="modal"
      width="375px"
      :visible.sync="callbackModal"
      title="管理回調"
    >
      <el-dialog
        width="375px"
        title="確認管理回調"
        :visible.sync="callbackModalInner"
        append-to-body
      >
        <p>訂單號{{ currentData.transaction_id }}</p>
        <p class="text-danger">
          未經代理要求，請勿操作！此操作將再次回調通知商戶訂單結果，若因此重複通知而造成資金上的糾紛，請自行處理。
        </p>
        <div slot="footer" class="dialog-footer btnGroup">
          <div @click="editPayModalInner = false" class="btn">關閉</div>
          <div @click="confirmCallback" class="btn">確定</div>
        </div>
      </el-dialog>
      <div class="modalBody">
        <p>訂單號{{ currentData.transaction_id }}</p>
        <p class="text-danger">
          未經代理要求，請勿操作！此操作將再次回調通知商戶訂單結果，若因此重複通知而造成資金上的糾紛，請自行處理。
        </p>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="callbackModal = false" class="oBtn">關閉</div>
        <div @click="callbackModalInner = true" class="oBtn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      width="375px"
      :visible.sync="manualReplyModal"
      title="手動回調商戶"
    >
      <div class="modalBody">
        <p>{{ currentData.transaction_id }}</p>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="manualReplyModal = false" class="oBtn">關閉</div>
        <div @click="forceOrder" class="oBtn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      width="80%"
      :visible.sync="editRefundModal"
      title="退款資訊"
    >
      <div class="modalBody">
        <p>
          退款狀態
          <span style="color:red;margin-bottom:15px">{{
            refund_status[currentData.refund_status]
          }}</span>
        </p>
        <el-table
          stripe
          :data="logList"
          border
          style="width: 100%;margin-top:18px"
        >
          <el-table-column
            header-align="center"
            align="center"
            prop="bank_account_name"
            label="戶名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="bank_name"
            label="銀行名稱"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="bank_no"
            label="銀行帳號"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="bank_province"
            label="銀行省份"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="bank_city"
            label="銀行城市"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="bank_sub_branch"
            label="銀行支行"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="phone"
            label="手機號"
          >
          </el-table-column>
        </el-table>
        <div v-if="currentData.refund_status == 1">
          <el-select v-model="refundStatus" placeholder="請選擇訂單狀態">
            <el-option label="退款成功" value="2"> </el-option>
            <el-option label="退款失敗" value="3"> </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div
          @click="editRefundModal = false"
          class="btn"
          :class="{ oBtn: currentData.refund_status != 1 }"
        >
          關閉
        </div>
        <div
          @click="ConfirmEditRefund"
          v-if="currentData.refund_status == 1"
          class="btn"
        >
          確認更改
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      width="375px"
      :visible.sync="requestRecordModal"
      title="請求紀錄"
    >
      <div class="modalBody">
        <p style="color:red;margin-bottom:15px">
          紀錄只限2天內訂單，若超過請洽技術
        </p>
        <pre
          style="word-break: break-all;white-space: pre-wrap;"
          class="text-white"
          v-if="ladingContent"
          >{{ ladingContent }}</pre
        >
        <el-button
          size="mini"
          type="button"
          class="btn text-nowrap ml-1"
          v-if="!ladingContent"
          @click="ladingShow"
        >
          三方提單
        </el-button>
        <el-button
          size="mini"
          type="button"
          class="btn text-nowrap ml-1"
          @click="orderNotificationShow"
          v-if="!ladingContent && currentData.type == 801"
        >
          通知商戶
        </el-button>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="requestRecordModal = false" class="oBtn">確定</div>
      </div>
    </el-dialog>
    <el-dialog
      class="modal"
      width="80%"
      :visible.sync="transactionsEventModal"
      title="訂單日誌"
    >
      <div class="modalBody">
        <el-table
          stripe
          :data="logList"
          border
          style="width: 100%;margin-top:18px"
        >
          <el-table-column
            header-align="center"
            align="center"
            prop="type_ch"
            label="類型"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="created_at"
            label="時間"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="user_id"
            label="操作人"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="note"
            label="備註"
          >
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer btnGroup">
        <div @click="transactionsEventModal = false" class="oBtn">確定</div>
      </div>
    </el-dialog>
    <el-form :inline="true" :model="searchData" class="demo-form-inline">
      <el-form-item label="">
        <div class="radioForm">
          <div class="radioWrap">
            <el-radio v-model="radio" label="1">創建時間</el-radio>
            <el-radio v-model="radio" label="2">完成時間</el-radio>
          </div>
          <el-date-picker
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="currentDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="開始日期"
            end-placeholder="結束日期"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="{ disabledDate: $store.state.disabledDate }"
          >
          </el-date-picker>
        </div>
      </el-form-item>
      <el-form-item label="商戶號" v-if="$store.state.userStatus != 'customer'">
        <el-input
          v-model="searchData.customer_id"
          placeholder="商戶號"
        ></el-input>
      </el-form-item>
      <el-form-item label="訂單編號">
        <el-input
          v-model="searchData.transaction_id"
          placeholder="訂單編號"
        ></el-input>
      </el-form-item>
      <el-form-item label="下單金額">
        <el-input
          v-model="searchData.amount_total"
          placeholder="下單金額"
        ></el-input>
      </el-form-item>
      <el-form-item label="實際金額">
        <el-input
          v-model="searchData.real_amount"
          placeholder="實際金額"
        ></el-input>
      </el-form-item>
      <el-form-item label="真實姓名">
        <el-input
          v-model="searchData.user_name"
          placeholder="真實姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="永豐虛擬帳號">
        <el-input
          v-model="searchData.payNo"
          placeholder="永豐虛擬帳號"
        ></el-input>
      </el-form-item>
      <el-form-item label="三方渠道">
        <el-select v-model="searchData.method_id" placeholder="三方渠道">
          <el-option label="全部" value=""> </el-option>
          <el-option
            v-for="item in methodList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="訂單狀態">
        <el-select v-model="searchData.status" placeholder="訂單狀態">
          <el-option label="全部" value=""> </el-option>
          <el-option
            :label="status"
            :value="key"
            v-for="(status, key) in orderStatus"
            :key="key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="訂單類型">
        <el-select v-model="searchData.type" placeholder="訂單類型">
          <el-option label="全部" value=""> </el-option>
          <el-option label="自動代收" value="801"> </el-option>
          <el-option label="新增訂單" value="805"> </el-option>
          <el-option label="商戶內充" value="806"> </el-option>
          <el-option label="玩家直沖" value="808"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="
            page = 1;
            inSearch = true;
            saveData = false;
            getData();
          "
          >搜尋</el-button
        >
      </el-form-item>
    </el-form>
    <div style="margin-top:18px">
      <el-button
        @click="exportModal = true"
        size="mini"
        v-if="$permission('collections.transactions.export')"
        >導出數據
      </el-button>
      <p style="margin-top:18px;font-size:18px" v-if="except">
        <span>共{{ except.totalCount }}筆 </span>
        <span>成功筆數:{{ except.successCount | thousands }} </span>
        <span
          >成功金額:{{ except.successAmount | decimalPoint | thousands }}
        </span>
        <span
          >手續費總計:{{ except.successFee | decimalPoint | thousands }}
        </span>
      </p>
      <el-table
        :data="dataList"
        border
        style="width: 100%;margin-top:18px"
        :row-class-name="tableRowClassName"
      >
        <af-table-column
          header-align="center"
          align="center"
          prop="type_alias"
          label="類型"
        >
        </af-table-column>
        <af-table-column
          :min-width="20"
          header-align="center"
          align="center"
          prop="channel_alias"
          label="支付渠道"
        >
        </af-table-column>
        <af-table-column
          :min-width="20"
          header-align="center"
          align="left"
          prop="ct_id"
          label="商戶訂單號"
        >
          <template slot-scope="scope">
            <div>
              <p v-if="scope.row.ct_id">商戶訂單號 {{ scope.row.ct_id }}</p>
              <p
                v-if="
                  scope.row.rc_feedback &&
                    JSON.parse(scope.row.rc_feedback).payer_info
                "
              >
                付款人帳號/店號
                {{ JSON.parse(scope.row.rc_feedback).payer_info }}
              </p>
              <p
                v-if="
                  JSON.parse(scope.row.rc_feedback) &&
                    JSON.parse(scope.row.rc_feedback).bank_no
                "
              >
                繳款帳號/代碼 {{ JSON.parse(scope.row.rc_feedback).bank_no }}
              </p>
            </div>
          </template>
        </af-table-column>
        <af-table-column
          :min-width="20"
          header-align="center"
          align="center"
          prop="transaction_id"
          label="系統訂單號"
        >
          <template slot-scope="scope">
            <el-tooltip
              style="cursor:pointer"
              v-clipboard:copy="scope.row.transaction_id"
              v-clipboard:success="$onCopy"
              class="item copyHover"
              effect="dark"
              content="點擊複製"
              placement="top"
            >
              <p>
                {{ scope.row.transaction_id }}
              </p>
            </el-tooltip>
          </template>
        </af-table-column>
        <af-table-column
          :min-width="20"
          header-align="center"
          align="center"
          prop="customer_id"
          label="商戶號"
          v-if="$store.state.userStatus != 'customer'"
        >
        </af-table-column>
        <af-table-column
          :min-width="150"
          header-align="center"
          align="right"
          prop="amount_total"
          label="下單金額"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.amount_total | decimalPoint | thousands }}
            </div>
          </template>
        </af-table-column>
        <af-table-column
          :min-width="20"
          header-align="center"
          align="right"
          prop="real_amount"
          label="實際金額"
        >
          <template slot-scope="scope">
            <div>
              <p v-if="scope.row.status != 7">
                {{ (scope.row.real_amount * 1) | thousands }}
              </p>
              <p v-else>
                0
              </p>
            </div>
          </template>
        </af-table-column>
        <af-table-column
          :min-width="20"
          header-align="center"
          align="right"
          label="手續費"
        >
          <template slot-scope="scope">
            <div>
              <p v-if="scope.row.status == 1 || scope.row.status == 2">
                {{
                  (scope.row.real_amount - scope.row.amount_customer)
                    | decimalPoint
                    | thousands
                }}
              </p>
            </div>
          </template>
        </af-table-column>
        <af-table-column
          :min-width="20"
          header-align="center"
          align="right"
          prop="amount_customer"
          label="實收金額"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.status == 1 || scope.row.status == 2">
              {{ scope.row.amount_customer | decimalPoint | thousands }}
            </div>
          </template>
        </af-table-column>
        <!-- <af-table-column
          header-align="center"
          align="center"
          prop="channel_alias"
          label="渠道"
        >
        </af-table-column> -->
        <af-table-column
          header-align="center"
          align="center"
          prop="grant_at"
          label="撥款日"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.grant_at ? $returnTime(scope.row.grant_at) : "" }}
            </div>
          </template>
        </af-table-column>
        <af-table-column
          :min-width="20"
          header-align="center"
          align="center"
          prop="created_at"
          label="創建時間"
        >
        </af-table-column>
        <af-table-column
          :min-width="20"
          header-align="center"
          align="center"
          prop="completed_at"
          label="完成時間"
        >
        </af-table-column>

        <af-table-column
          header-align="center"
          width="150"
          align="center"
          prop="status_alias"
          label="狀態"
        >
        </af-table-column>
        <af-table-column
          header-align="center"
          align="center"
          prop="status_alias"
          label="操作"
        >
          <template slot-scope="scope">
            <div style="display:flex">
              <!-- <el-button
                size="mini"
                v-if="
                  $store.state.userStatus != 'agent' &&
                    $store.state.userStatus != 'agentSub' &&
                    $store.state.userStatus != 'subagent' &&
                    $store.state.userStatus != 'agentSub' &&
                    $store.state.userStatus != 'customer' &&
                    $store.state.userStatus != 'customerSub'
                "
                type="button"
                class="btn text-nowrap ml-1"
                @click="requestRecord(scope.row)"
              >
                請求紀錄
              </el-button> -->
              <el-button
                size="mini"
                v-if="
                  scope.row.status == 8 &&
                    $permission('collections.transactions.legalAccount')
                "
                type="button"
                class="btn text-nowrap ml-1"
                @click="legalAccount(scope.row)"
              >
                確認支付方式
              </el-button>
              <el-button
                size="mini"
                v-if="$permission('collections.transactions.events')"
                type="button"
                class="btn text-nowrap ml-1"
                @click="showEvent(scope.row)"
              >
                訂單日誌
              </el-button>
              <!-- <el-button
                size="mini"
                v-if="
                  $permission('collections.transactions.refund') &&
                    scope.row.status == 7
                "
                type="button"
                class="btn text-nowrap ml-1"
                @click="editRefund(scope.row)"
              >
                退款資訊
              </el-button> -->
              <el-button
                size="mini"
                v-if="
                  $permission('collections.transactions.manualCallback') &&
                    scope.row.notify_url != null &&
                    scope.row.status == 1
                "
                type="button"
                class="btn text-nowrap ml-1"
                @click="manualReply(scope.row)"
              >
                手動回調
              </el-button>
              <el-button
                size="mini"
                v-if="
                  $permission('collections.transactions.forceOrder') &&
                    (scope.row.status == 0 || scope.row.status == 3)
                "
                type="button"
                class="btn text-nowrap ml-1"
                @click="editPay(scope.row)"
              >
                設置為已支付
              </el-button>
              <el-button
                size="mini"
                v-if="
                  $permission('collections.transactions.callback') &&
                    (scope.row.status == 1 || scope.row.status == 2) &&
                    scope.row.counter == 0
                "
                type="button"
                class="btn text-nowrap ml-1"
                @click="callback(scope.row)"
              >
                管理回調
              </el-button>
              <el-button
                size="mini"
                type="button"
                v-if="scope.row.detail"
                class="btn text-nowrap ml-1"
                @click="info(scope.row)"
              >
                查看詳情
              </el-button>
              <el-button
                size="mini"
                v-if="rateBtn(scope.row)"
                type="button"
                class="btn text-nowrap ml-1"
                @click="showRate(scope.row)"
              >
                查看匯率
              </el-button>
              <el-button
                size="mini"
                v-if="
                  scope.row.t_feedback &&
                    scope.row.status == 5 &&
                    $store.state.userStatus != 'customer' &&
                    $store.state.userStatus != 'customerSub'
                "
                type="button"
                class="btn text-nowrap ml-1"
                @click="errView(scope.row)"
              >
                查看錯誤
              </el-button>
              <el-button
                size="mini"
                v-if="
                  $permission('collections.transactions.queryOrder') &&
                    (scope.row.type == 801 ||
                      scope.row.type == 805 ||
                      scope.row.type == 806 ||
                      scope.row.type == 808)
                "
                class="btn btn-green ml-1"
                @click="checklist(scope.row)"
              >
                三方查單
              </el-button>
              <el-button
                size="mini"
                v-if="
                  $permission('collections.transactions.realAmount') &&
                    scope.row.status == 4
                "
                class="btn btn-green ml-1"
                @click="checkAmount(scope.row)"
              >
                確認真實金額
              </el-button>

              <el-button
                size="mini"
                v-if="scope.row.type == 808"
                class="btn btn-green ml-1"
                @click="showCustomerInfo(scope.row)"
              >
                商戶詳情
              </el-button>
              <el-button
                size="mini"
                v-if="returnLegal(scope.row.c_detail)"
                class="btn btn-green ml-1"
                @click="showLegalAccount(scope.row)"
              >
                合法帳號
              </el-button>
            </div>
          </template>
        </af-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          :current-page.sync="page"
          layout="prev, pager, next"
          :page-count="pagination.total_page"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      feeTotal: 0,
      successAmount: 0,
      successCount: 0,
      feedback: {},
      orderInfoModal: false,
      callbackModalInner: false,
      callbackModal: false,
      editPayModal: false,
      editPayModalInner: false,
      page: 1,
      inSearch: false,
      saveData: false,
      searchData: {},
      reqNotifyData: false,
      reqLogData: false,
      dataList: [],
      pagination: {},
      methodList: [],
      currentDate: [],
      methodId: "",
      radio: "1",
      requestRecordModal: false,
      currentData: {
        model_id: 53,
        client_ip: "34.92.245.74",
        user_name: "",
        legal_account: ["12345", "00000"]
      },
      currentOrder: {},
      ladingContent: false,
      transactionsEventModal: false,
      logList: [],
      editRefundModal: false,
      refundStatus: "",
      manualReplyModal: false,
      refund_status: {
        "0": "退款準備",
        "1": "退款中",
        "2": "退款成功",
        "3": "退款失敗"
      },
      rateTable: {},
      rateTableModal: false,
      errorViewContent: {},
      errorModal: false,
      queryOrderModal: false,
      queryOrderInner: false,
      queryOrderData: {},
      checkAmountModal: false,
      checkAmountInner: false,
      exportId: "",
      exportDate: [],
      exportModal: false,
      exportRadio: "created_at",
      except: "",
      orderStatus: [],
      legalAccountModal: false,
      legalAccountInner: false,
      legalAccountDialog: false
    };
  },
  watch: {
    page() {
      if (this.inSearch) {
        this.inSearch = false;
        return;
      }
      this.getData();
    }
  },
  methods: {
    returnLegal(data) {
      try {
        let detail = JSON.parse(data);
        if (detail.legal_account) {
          return true;
        } else {
          return false;
        }
      } catch {
        return false;
      }
    },
    showLegalAccount(data) {
      let detail = JSON.parse(data.c_detail);
      this.currentData = detail;
      this.legalAccountDialog = true;
    },
    tableRowClassName({ row }) {
      if (
        JSON.parse(row.c_detail).billing_area !=
        JSON.parse(row.c_detail).checkout_area
      ) {
        return "warningTable";
      }
    },
    confirmExport() {
      let sendData;
      if (this.saveData) {
        sendData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        sendData = {};
      }
      if (this.exportDate[0]) {
        sendData.date_start = this.exportDate[0];
        sendData.date_end = this.exportDate[1];
      }
      sendData.target_id = this.exportId;
      sendData.lifting_time = this.exportRadio;
      this.$http
        .get(`/back/collection/transactions/export`, {
          params: sendData
        })
        .then(res => {
          if (res.data.code == 0) {
            window.open(`/back/export/${res.data.data}`);
          }
        });
    },
    showCustomerInfo(el) {
      this.$alert(el.c_detail, "商戶詳情");
    },
    confirmLegalAccount() {
      this.$http
        .post(`/back/collection/transactions/legal_account`, {
          id: this.currentData.id
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.legalAccountModal = false;
            this.legalAccountInner = false;
          }
        });
    },
    legalAccount(list) {
      let data = JSON.parse(JSON.stringify(list));
      this.legalAccountModal = true;
      this.currentData = data;
    },
    confirmCheckAmount() {
      this.$http
        .post(`/back/collection/transactions/real_amount`, {
          id: this.currentData.id
        })
        .then(res => {
          if (res.data.code == 0) {
            this.$message.success("成功");
            this.checkAmountModal = false;
            this.checkAmountInner = false;
          }
        });
    },
    checkAmount(list) {
      let data = JSON.parse(JSON.stringify(list));
      this.checkAmountModal = true;
      this.currentData = data;
    },
    confirmQueryOrder() {
      this.$http
        .post(`/back/collection/transactions/query_order`, {
          transaction_id: this.currentData.transaction_id
        })
        .then(res => {
          if (res.data.code == 0) {
            let msg = res.data.data.result || res.data.data;
            if (typeof msg == "object") {
              this.queryOrderData = msg;
            } else {
              this.queryOrderData = res.data.data.message || res.data.data;
            }
            this.queryOrderInner = true;
            this.queryOrderModal = false;
          }
        });
    },
    checklist(list) {
      this.currentData = JSON.parse(JSON.stringify(list));
      this.queryOrderModal = true;
    },
    errView(el) {
      if (!el.t_feedback || String(el.t_feedback) == "null") {
        this.errorViewContent = "null";
        this.errorModal = true;
        return;
      }
      this.errorViewContent = JSON.parse(el.t_feedback);
      this.errorModal = true;
    },
    showRate(rate) {
      let rateTable = "";
      let rateData = "";
      if (rate.t_feedback && rate.t_feedback.rate) {
        rateData = JSON.parse(rate.t_feedback).rate;
      }
      if (JSON.parse(rate.t_feedback) && JSON.parse(rate.t_feedback).data) {
        rateData = JSON.parse(rate.t_feedback).data.rate;
      }
      if (JSON.parse(rate.c_detail).trans) {
        rateTable = JSON.parse(rate.c_detail);
      }
      if (rateTable) {
        this.rateTable = rateTable;
      } else {
        this.rateTable = {
          nTable: true,
          rate: rateData
        };
      }
      this.rateTableModal = true;
    },
    rateBtn(el) {
      if (el.t_feedback && el.t_feedback != "null") {
        if (JSON.parse(el.t_feedback).rate) {
          return true;
        }
        if (
          JSON.parse(el.t_feedback).data &&
          JSON.parse(el.t_feedback).data.rate
        ) {
          return true;
        }
      }
      if (el.c_detail && el.c_detail != "null") {
        if (
          JSON.parse(el.c_detail).trans &&
          JSON.parse(el.c_detail).trans.rate
        ) {
          return false;
        } else {
          if (JSON.parse(el.c_detail).trans) {
            return true;
          }
        }
      }
      return false;
    },
    async info(info) {
      this.reqLogData = false;
      this.reqNotifyData = false;
      let data = JSON.parse(JSON.stringify(info));
      this.currentData = data;
      // if (
      //   (this.$store.state.userStatus != "agent" &&
      //     this.$store.state.userStatus != "agentSub" &&
      //     this.$store.state.userStatus != "subagent" &&
      //     this.$store.state.userStatus != "agentSub" &&
      //     this.$store.state.userStatus != "customer" &&
      //     this.$store.state.userStatus != "customerSub")
      // ) {
      await this.$http
        .get(`/back/orderRequestLog/${data.transaction_id}`)
        .then(res => {
          if (res.data.code == 0) {
            if (Array.isArray(res.data.data)) {
              this.reqLogData = {};
            } else {
              let resData = res.data.data;
              if (typeof resData == "object") {
                Object.keys(resData).forEach(e => {
                  if (typeof resData[e] == "object") {
                    resData[e] = JSON.parse(JSON.stringify(resData[e]), 2);
                  }
                });
              }
              this.reqLogData = resData || {};
            }
          }
        });
      await this.$http
        .get(`/back/orderNotificationLog/${data.transaction_id}`)
        .then(res => {
          if (res.data.code == 0) {
            if (Array.isArray(res.data.data)) {
              this.reqNotifyData = {};
            } else {
              let resData = res.data.data;
              if (typeof resData == "object") {
                Object.keys(resData).forEach(e => {
                  if (typeof resData[e] == "object") {
                    resData[e] = JSON.parse(JSON.stringify(resData[e]), 2);
                  }
                });
              }
              this.reqNotifyData = resData || {};
            }
          }
        });
      // }
      this.orderInfoModal = true;
    },
    confirmCallback() {
      this.$http
        .post(`/back/collection/transactions/${this.currentData.id}/callback`)
        .then(res => {
          if (res.data.code == 0) {
            (this.callbackModalInner = false),
              (this.callbackModal = false),
              this.$message.success("成功");
          }
        });
    },
    callback(list) {
      let data = JSON.parse(JSON.stringify(list));
      this.currentData = data;
      this.callbackModal = true;
    },
    confirmEditPay() {
      let data = {
        payer_info: this.currentData.payer_info,
        transaction_id: this.currentData.transaction_id,
        amount: this.currentData.amount
      };
      this.$http
        .post(`/back/collection/transactions/force_order`, data)
        .then(res => {
          if (res.data.code == 0) {
            this.editPayModalInner = false;
            this.editPayModal = false;
            this.getData();
            this.$message.success("設置成功");
          }
        });
    },
    editPay(user) {
      user.saveData = this.saveData;
      this.currentData = user;
      this.editPayModal = true;
    },
    forceOrder() {
      let data = {
        transaction_id: this.currentData.transaction_id
      };
      this.$http
        .post(`/back/collection/transactions/manual_callback`, data)
        .then(res => {
          if (res.data.code == 0) {
            this.manualReplyModal = false;
            this.$message.success("設置成功");
          }
        });
      this.getData();
    },
    manualReply(list) {
      this.manualReplyModal = true;
      this.currentData = JSON.parse(JSON.stringify(list));
    },
    editRefund(list) {
      this.refundStatus = "";
      this.currentOrder = JSON.parse(JSON.stringify(list));
      let data = JSON.parse(JSON.stringify(list.c_detail));
      this.currentData = JSON.parse(data).refund;
      this.editRefundModal = true;
    },
    showEvent(data) {
      this.$http
        .get(`/back/collection/transactions/${data.transaction_id}/events`)
        .then(res => {
          if (res.data.code == 0) {
            this.transactionsEventModal = true;
            this.logList = JSON.parse(JSON.stringify(res.data.data));
          }
        });
    },
    getData() {
      let searchData = {};
      if (this.saveData) {
        searchData = JSON.parse(JSON.stringify(this.saveData));
      } else {
        searchData = JSON.parse(JSON.stringify(this.searchData));
        if (this.currentDate) {
          searchData.date_start = this.currentDate[0];
          searchData.date_end = this.currentDate[1];
        }
        searchData.lifting_time =
          this.radio == 1 ? "created_at" : "completed_at";
      }
      Object.keys(searchData).forEach(e => {
        if (!searchData[e] && String(searchData[e]) !== "0") {
          delete searchData[e];
        }
      });
      searchData.page = this.page;
      this.$http
        .post(`/back/collection/transactions/search`, searchData)
        .then(res => {
          if (res.data.code == 0) {
            this.saveData = JSON.parse(JSON.stringify(searchData));
            this.inSearch = false;
            this.dataList = res.data.data;
            this.pagination = res.data.paginate;
            let successAmount = 0,
              successCount = 0,
              feeTotal = 0;
            this.dataList.forEach(list => {
              if (list.status == 1 || list.status == 2) {
                feeTotal += list.real_amount * 1 - list.amount_customer * 1;
              }
              if (list.status == 1 || list.status == 2 || list.status == 4) {
                successAmount++;
                successCount = successCount * 1 + list.amount_customer * 1;
              }
            });
            this.successAmount = successAmount;
            this.successCount = successCount;
            this.feeTotal = feeTotal;
            if (res.data.except && searchData.page == 1) {
              this.except = res.data.except;
            }
          }
        });
    },
    getSelect() {
      this.$http.get(`/back/methods/select`).then(res => {
        if (res.data.code == 0) {
          this.methodList = res.data.data;
        }
      });
    },
    requestRecord(list) {
      this.ladingContent = false;
      this.currentData = JSON.parse(JSON.stringify(list));
      this.requestRecordModal = true;
    },
    ladingShow() {
      this.$http
        .get(`/back/orderRequestLog/${this.currentData.transaction_id}`)
        .then(res => {
          if (res.data.code == 0) {
            if (typeof res.data.data == "object") {
              this.ladingContent = res.data.data;
            } else {
              this.ladingContent = JSON.parse(res.data.data);
            }
          }
        });
    },
    orderNotificationShow() {
      this.$http
        .get(`/back/orderNotificationLog/${this.currentData.transaction_id}`)
        .then(res => {
          if (res.data.code == 0) {
            if (typeof res.data.data == "object") {
              this.ladingContent = res.data.data;
            } else {
              this.ladingContent = JSON.parse(res.data.data);
            }
          }
        });
    }
  },
  created() {
    this.getSelect();
    this.getData();
    this.$http.get(`/back/status/transaction`).then(res => {
      if (res.data.code == 0) {
        this.orderStatus = res.data.data;
      }
    });
  }
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
